import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { RadioGroup, Radio } from 'informed';

import { Label } from '../../Typography.jsx';
import { Button, PrimaryButton } from '../../Buttons.jsx';

import styles from '../../../styles/patientPages/testing/HIV.scss';

import {
  updateHIVMotherStatus,
} from '../../../actions/testingActions';

type Props = {
  activePatientId: string,
  dateArrived: string,
  hivMotherStatus: bool,
  hivTestExists: bool,
  formApi: Object,
  updateHIVMotherStatus: Function,
  print: boolean,
  admissionHivTest6: Object,
}

type State = {
  editing: bool,
}

class HIVInfoComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      editing: false,
    };
  }

  onCancel = () => {
    this.setState({
      editing: false,
    });
  }

  onSave = () => {
    const state = this.props.formApi.getState();
    if (state.invalid) {
      return;
    }
    const { status } = state.values;
    this.props.updateHIVMotherStatus(this.props.activePatientId, status);
    this.setState({
      editing: false,
    });
  }

  onEdit = () => {
    this.setState({
      editing: true,
    });
  }

  render() {
    const dateArrived = this.props.dateArrived
      ? moment(this.props.dateArrived).format() : this.props.dateArrived;
    const sixWeeks = this.props.dateArrived
      ? moment(this.props.dateArrived).add(6, 'weeks').format() : this.props.dateArrived;

    const statusContent = this.state.editing
      ? (
        <RadioGroup field='status' initialValue={this.props.hivMotherStatus}>
          <Radio value={'Positive'} />Positive
          <br />
          <Radio value={'Negative'} />Negative
          <br />
          <Radio value={'Unknown'} />Unknown
        </RadioGroup>
      ) : (
        this.props.hivMotherStatus || '--'
      );

    const statusButtons = this.state.editing
      ? (
        <div>
          <PrimaryButton onClick={this.onSave}>Save</PrimaryButton>
          <br />
          <Button onClick={this.onCancel}>Cancel</Button>
        </div>
      ) : (
        !this.props.print && <PrimaryButton onClick={this.onEdit}>Edit</PrimaryButton>
      );

    return (
      <table className={styles.contentContainer}>
        <tbody>
          <tr>
            <td><Label>{'Mother\'s Status: '}</Label></td>
            <td>{statusContent}</td>
            <td>{statusButtons}</td>
          </tr>
          {!this.props.print
            && <tr>
              <td><Label>Date Arrived at PC: </Label></td>
              <td>{dateArrived || '--'}</td>
            </tr>
          }
          {!this.props.print
            && this.props.admissionHivTest6
            && <tr>
              <td><Label>Second Test Due (6 wks from arrival): </Label></td>
              <td>
                {sixWeeks || '--'}
              </td>
            </tr>
          }
        </tbody>
      </table>
    );
  }
}

const mapStateToProps = state => ({
  activePatientId: state.patient.data.activePatientId,
  dateArrived: state.patient.data.generalInfo.dateArrived,
  hivMotherStatus: state.patient.data.testing.hivMotherStatus,
  print: state.patient.print,
  admissionHivTest6: state.patient.data.testing.admissionHivTest6,
});

const mapDispatchToProps = dispatch => ({
  updateHIVMotherStatus:
    (patientId, status) => dispatch(updateHIVMotherStatus(patientId, status)),
});

const HIVInfo = connect(
  mapStateToProps,
  mapDispatchToProps,
)(HIVInfoComponent);

export default HIVInfo;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/testing/HIVInfo.jsx